<template>
  <div class="sidebar-wrap">
    <!-- 菜单 -->
    <scroll-bar class="sidebar-menu">
      <el-menu
        mode="vertical"
        :show-timeout="200"
        :default-active="$route.path"
        :collapse="isCollapse"
        background-color="#ffffff"
        text-color="#4e5969"
        active-text-color="#3b6ff5"
      >
        <sidebar-item :routes="routes"></sidebar-item>
      </el-menu>
    </scroll-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style scoped>
.sidebar-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 菜单区 */
.sidebar-menu {
  flex: 1;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue